"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  filterWords: function filterWords() {
    return _filterWords;
  },
  useComboboxInput: function useComboboxInput() {
    return _useComboboxInput;
  },
  useHTMLInputCursorState: function useHTMLInputCursorState() {
    return _useHTMLInputCursorState;
  },
  withTriggerCombobox: function withTriggerCombobox() {
    return _withTriggerCombobox;
  }
});
module.exports = __toCommonJS(src_exports);

// src/withTriggerCombobox.ts
var import_server = require("@udecode/plate-common/server");
var _withTriggerCombobox = function _withTriggerCombobox(editor, _ref) {
  var _ref$options = _ref.options,
    createComboboxInput = _ref$options.createComboboxInput,
    trigger = _ref$options.trigger,
    triggerPreviousCharPattern = _ref$options.triggerPreviousCharPattern,
    triggerQuery = _ref$options.triggerQuery,
    type = _ref.type;
  var insertText = editor.insertText;
  var matchesTrigger = function matchesTrigger(text) {
    if (trigger instanceof RegExp) {
      return trigger.test(text);
    }
    if (Array.isArray(trigger)) {
      return trigger.includes(text);
    }
    return text === trigger;
  };
  editor.insertText = function (text) {
    if (!editor.selection || !matchesTrigger(text) || triggerQuery && !triggerQuery(editor)) {
      return insertText(text);
    }
    var previousChar = (0, import_server.getEditorString)(editor, (0, import_server.getRange)(editor, editor.selection, (0, import_server.getPointBefore)(editor, editor.selection)));
    var matchesPreviousCharPattern = triggerPreviousCharPattern == null ? void 0 : triggerPreviousCharPattern.test(previousChar);
    if (matchesPreviousCharPattern) {
      var inputNode = createComboboxInput ? createComboboxInput(text) : {
        children: [{
          text: ""
        }],
        type: type
      };
      return editor.insertNode(inputNode);
    }
    return insertText(text);
  };
  return editor;
};

// src/hooks/useComboboxInput.ts
var import_react = require("react");
var import_plate_common = require("@udecode/plate-common");
var import_server2 = require("@udecode/plate-common/server");
var import_slate_react = require("slate-react");
var _useComboboxInput = function _useComboboxInput(_ref2) {
  var _ref2$autoFocus = _ref2.autoFocus,
    autoFocus = _ref2$autoFocus === void 0 ? true : _ref2$autoFocus,
    _ref2$cancelInputOnAr = _ref2.cancelInputOnArrowLeftRight,
    cancelInputOnArrowLeftRight = _ref2$cancelInputOnAr === void 0 ? true : _ref2$cancelInputOnAr,
    _ref2$cancelInputOnBa = _ref2.cancelInputOnBackspace,
    cancelInputOnBackspace = _ref2$cancelInputOnBa === void 0 ? true : _ref2$cancelInputOnBa,
    _ref2$cancelInputOnBl = _ref2.cancelInputOnBlur,
    cancelInputOnBlur = _ref2$cancelInputOnBl === void 0 ? true : _ref2$cancelInputOnBl,
    _ref2$cancelInputOnDe = _ref2.cancelInputOnDeselect,
    cancelInputOnDeselect = _ref2$cancelInputOnDe === void 0 ? true : _ref2$cancelInputOnDe,
    _ref2$cancelInputOnEs = _ref2.cancelInputOnEscape,
    cancelInputOnEscape = _ref2$cancelInputOnEs === void 0 ? true : _ref2$cancelInputOnEs,
    cursorState = _ref2.cursorState,
    _ref2$forwardUndoRedo = _ref2.forwardUndoRedoToEditor,
    forwardUndoRedoToEditor = _ref2$forwardUndoRedo === void 0 ? true : _ref2$forwardUndoRedo,
    onCancelInput = _ref2.onCancelInput,
    ref = _ref2.ref;
  var _a, _b;
  var editor = (0, import_plate_common.useEditorRef)();
  var element = (0, import_plate_common.useElement)();
  var selected = (0, import_slate_react.useSelected)();
  var cursorAtStart = (_a = cursorState == null ? void 0 : cursorState.atStart) != null ? _a : false;
  var cursorAtEnd = (_b = cursorState == null ? void 0 : cursorState.atEnd) != null ? _b : false;
  var removeInput = (0, import_react.useCallback)(function () {
    var shouldFocusEditor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var path = (0, import_plate_common.findNodePath)(editor, element);
    if (!path) return;
    (0, import_server2.removeNodes)(editor, {
      at: path
    });
    if (shouldFocusEditor) {
      (0, import_plate_common.focusEditor)(editor);
    }
  }, [editor, element]);
  var cancelInput = (0, import_react.useCallback)(function () {
    var cause = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "manual";
    var shouldFocusEditor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    removeInput(shouldFocusEditor);
    onCancelInput == null ? void 0 : onCancelInput(cause);
  }, [onCancelInput, removeInput]);
  (0, import_react.useEffect)(function () {
    var _a2;
    if (autoFocus) {
      (_a2 = ref.current) == null ? void 0 : _a2.focus();
    }
  }, [autoFocus, ref]);
  var previousSelected = (0, import_react.useRef)(selected);
  (0, import_react.useEffect)(function () {
    if (previousSelected.current && !selected && cancelInputOnDeselect) {
      cancelInput("deselect");
    }
    previousSelected.current = selected;
  }, [selected, cancelInputOnDeselect, cancelInput]);
  return {
    cancelInput: cancelInput,
    props: {
      onBlur: function onBlur() {
        if (cancelInputOnBlur) {
          cancelInput("blur");
        }
      },
      onKeyDown: function onKeyDown(event) {
        if (cancelInputOnEscape && (0, import_server2.isHotkey)("escape", event)) {
          cancelInput("escape", true);
        }
        if (cancelInputOnBackspace && cursorAtStart && (0, import_server2.isHotkey)("backspace", event)) {
          cancelInput("backspace", true);
        }
        if (cancelInputOnArrowLeftRight && cursorAtStart && (0, import_server2.isHotkey)("arrowleft", event)) {
          cancelInput("arrowLeft", true);
        }
        if (cancelInputOnArrowLeftRight && cursorAtEnd && (0, import_server2.isHotkey)("arrowright", event)) {
          cancelInput("arrowRight", true);
        }
        var isUndo = import_server2.Hotkeys.isUndo(event) && editor.history.undos.length > 0;
        var isRedo = import_server2.Hotkeys.isRedo(event) && editor.history.redos.length > 0;
        if (forwardUndoRedoToEditor && (isUndo || isRedo)) {
          event.preventDefault();
          editor[isUndo ? "undo" : "redo"]();
          (0, import_plate_common.focusEditor)(editor);
        }
      }
    },
    removeInput: removeInput
  };
};

// src/hooks/useHTMLInputCursorState.ts
var import_react2 = require("react");
var _useHTMLInputCursorState = function _useHTMLInputCursorState(ref) {
  var _ref3 = (0, import_react2.useState)(false),
    _ref4 = _slicedToArray(_ref3, 2),
    atStart = _ref4[0],
    setAtStart = _ref4[1];
  var _ref5 = (0, import_react2.useState)(false),
    _ref6 = _slicedToArray(_ref5, 2),
    atEnd = _ref6[0],
    setAtEnd = _ref6[1];
  var recomputeCursorState = (0, import_react2.useCallback)(function () {
    setTimeout(function () {
      if (!ref.current) return;
      var _ref$current = ref.current,
        selectionEnd = _ref$current.selectionEnd,
        selectionStart = _ref$current.selectionStart,
        value = _ref$current.value;
      setAtStart(selectionStart === 0);
      setAtEnd(selectionEnd === value.length);
    });
  }, [ref]);
  (0, import_react2.useEffect)(function () {
    recomputeCursorState();
    var input = ref.current;
    if (!input) return;
    input.addEventListener("input", recomputeCursorState);
    input.addEventListener("selectionchange", recomputeCursorState);
    input.addEventListener("keydown", recomputeCursorState);
    input.addEventListener("pointerdown", recomputeCursorState);
    input.addEventListener("pointerup", recomputeCursorState);
    return function () {
      input.removeEventListener("input", recomputeCursorState);
      input.removeEventListener("selectionchange", recomputeCursorState);
      input.removeEventListener("keydown", recomputeCursorState);
      input.removeEventListener("pointerdown", recomputeCursorState);
      input.removeEventListener("pointerup", recomputeCursorState);
    };
  }, [recomputeCursorState, ref]);
  return (0, import_react2.useMemo)(function () {
    return {
      atStart: atStart,
      atEnd: atEnd
    };
  }, [atStart, atEnd]);
};

// src/utils/filterWords.ts
var _filterWords = function _filterWords(haystack, needle) {
  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref7$prefixMode = _ref7.prefixMode,
    prefixMode = _ref7$prefixMode === void 0 ? "last-word" : _ref7$prefixMode,
    _ref7$wordBoundary = _ref7.wordBoundary,
    wordBoundary = _ref7$wordBoundary === void 0 ? /\s+/ : _ref7$wordBoundary,
    _ref7$wordQuantifier = _ref7.wordQuantifier,
    wordQuantifier = _ref7$wordQuantifier === void 0 ? "match-all" : _ref7$wordQuantifier;
  var haystackWords = haystack.trim().split(wordBoundary);
  var needleWords = needle.trim().split(wordBoundary);
  var quantifier = wordQuantifier === "match-all" ? "every" : "some";
  return needleWords[quantifier](function (needleWord, i) {
    var allowPrefix = function () {
      switch (prefixMode) {
        case "none":
          {
            return false;
          }
        case "all-words":
          {
            return true;
          }
        case "last-word":
          {
            return i === needleWords.length - 1;
          }
      }
    }();
    return haystackWords.some(function (unslicedHaystackWord) {
      var haystackWord = allowPrefix ? unslicedHaystackWord.slice(0, needleWord.length) : unslicedHaystackWord;
      return haystackWord.localeCompare(needleWord, void 0, {
        sensitivity: "base",
        usage: "search"
      }) === 0;
    });
  });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  filterWords: _filterWords,
  useComboboxInput: _useComboboxInput,
  useHTMLInputCursorState: _useHTMLInputCursorState,
  withTriggerCombobox: _withTriggerCombobox
});